import { render, staticRenderFns } from "./configuration-automatic-billable-concept-rules-modal.vue?vue&type=template&id=160e96b9&"
import script from "./configuration-automatic-billable-concept-rules-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-automatic-billable-concept-rules-modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports